/** Keep an unresolved instruction across modal closes and reloads. A different
 * amount is another explicit request; the server still enforces original cash. */
export async function postAdminOrderRefund(orderId:number,amountPence:number,headers:HeadersInit){
 const key=`admin-order-refund:${orderId}:${amountPence}`;
 let reference=sessionStorage.getItem(key);
 if(!reference){reference=crypto.randomUUID();sessionStorage.setItem(key,reference);}
 const response=await fetch(`/api/admin/orders/${orderId}/refund`,{method:'POST',headers,body:JSON.stringify({amountPence,idempotencyKey:reference})});
 // A 202 means a durable obligation, possibly still awaiting submission. Keep
 // its identity until a successful receipt can be confirmed on the same retry.
 return {response,acknowledge:()=>sessionStorage.removeItem(key)};
}
